/**
 * Presets are SHARED clinic templates; a preset must never carry the
 * patient-specific engraving name. Historically the whole `form.deep` was
 * stored, so `design.custom_name` leaked (e.g. ZIA's "Pes planus" preset
 * carried "HOLLAND", the Dubai clinic's preset a real patient name) and
 * re-appeared on every order the preset was applied to. We strip it BOTH on
 * save (no new leaks) and on apply (legacy presets that already contain a
 * name never write it into the form).
 */
export function stripPresetCustomName(
  config: Record<string, unknown>,
): Record<string, unknown> {
  const design = config.design as Record<string, unknown> | undefined;
  if (!design || !('custom_name' in design)) return config;
  const { custom_name: _dropped, ...restDesign } = design;
  return { ...config, design: restDesign };
}
